export const convertPriceToReadableFormat = (value) => {
	if (!value) return '0,00';
	const newValue = (parseFloat(value) * 0.01).toFixed(2);
	return newValue.toString().replace('.', ',');
};

export const convertPriceToDecimal = (value) => {
	const newValue = value ? (parseFloat(value) * 0.01).toFixed(2) : 0;
	return Number(newValue);
};
